import Vue from 'vue'

Vue.mixin({
    data() {
        return {
            projectPhaseOptions: [
                {
                    id: "initiation",
                    translationKey: "enums.project-phase.initiation"
                },
                {
                    id: "execution",
                    translationKey: "enums.project-phase.execution"
                },
                {
                    id: "closure",
                    translationKey: "enums.project-phase.closure"
                }
            ],
            userRoleOptions: [
                {
                    id: "inactive",
                    translationKey: "enums.user-role.inactive"
                },
                {
                    id: "site_manager",
                    translationKey: "enums.user-role.site-manager"
                },
                {
                    id: "project_manager",
                    translationKey: "enums.user-role.project-manager"
                },
                {
                    id: "admin",
                    translationKey: "enums.user-role.admin"
                },
                {
                    id: "system",
                    translationKey: "enums.user-role.system"
                }
            ],
            UserActions: {
                VIEW:"VIEW", CREATE:"CREATE", UPDATE:"UPDATE", DELETE:"DELETE"
            },
            durationUnits: [
                {
                    id: "undefined",
                    translationKey: "enums.undefined"
                },
                {
                    id: "minute",
                    translationKey: "enums.duration-unit.minute",
                    translationAbbrKey: "enums.duration-unitv.minute"
                },
                {
                    id: "hour",
                    translationKey: "enums.duration-unit.hour",
                    translationAbbrKey: "enums.duration-unit-short.hour"
                },
                {
                    id: "day",
                    translationKey: "enums.duration-unit.day",
                    translationAbbrKey: "enums.duration-unit-short.day"
                },
                {
                    id: "week",
                    translationKey: "enums.duration-unit.week",
                    translationAbbrKey: "enums.duration-unit-short.week"
                },
                {
                    id: "month",
                    translationKey: "enums.duration-unit.month",
                    translationAbbrKey: "enums.duration-unit-short.month"
                },
            ],
            quantityUnits: [
                {
                    id: "meter",
                    translationKey: "enums.quantity-unit.meter",
                    translationAbbrKey: "enums.quantity-unit-short.meter"
                },
                {
                    id: "square-meter",
                    translationKey: "enums.quantity-unit.square-meter",
                    translationAbbrKey: "enums.quantity-unit-short.square-meter"
                },
                {
                    id: "cubic-meter",
                    translationKey: "enums.quantity-unit.cubic-meter",
                    translationAbbrKey: "enums.quantity-unit-short.cubic-meter"
                },
                {
                    id: "km",
                    translationKey: "enums.quantity-unit.km",
                    translationAbbrKey: "enums.quantity-unit-short.km"
                },
                {
                    id: "ml", // linear meter
                    translationKey: "enums.quantity-unit.ml",
                    translationAbbrKey: "enums.quantity-unit-short.ml"
                },
                {
                    id: "unit",
                    translationKey: "enums.quantity-unit.unit",
                    translationAbbrKey: "enums.quantity-unit-short.unit"
                },
                {
                    id: "number",
                    translationKey: "enums.quantity-unit.number",
                    translationAbbrKey: "enums.quantity-unit-short.number"
                },
                {
                    id: "day",
                    translationKey: "enums.duration-unit.day",
                    translationAbbrKey: "enums.duration-unit-short.day"
                },
                {
                    id: "liter",
                    translationKey: "enums.quantity-unit.liter",
                    translationAbbrKey: "enums.quantity-unit-short.liter"
                },
                {
                    id: "kilogram",
                    translationKey: "enums.quantity-unit.kilogram",
                    translationAbbrKey: "enums.quantity-unit-short.kilogram"
                },
                {
                    id: "tonne",
                    translationKey: "enums.quantity-unit.tonne",
                    translationAbbrKey: "enums.quantity-unit-short.tonne"
                },
            ],
            personalGroupOptions: [
                {
                    id: "internal",
                    translationKey: "enums.personal-group.internal"
                },
                {
                    id: "external",
                    translationKey: "enums.personal-group.external"
                }
            ],
            defaultValues: {
                quantityUnitId: "unit",
                priceUnit: "€",
                localDateFormat: "fr-FR",
                equipmentQuantityUnitId: "day"
            }
        }
    }
})